import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { ApproveOrRejectSelectedAsync, getAllExpenseEntryApprovalsAsync, setPageSize, setSortConfig, setDateRangeValue, setIsRemoveFilterSetting } from "./ExpenseApprovalSlice";
import OffCanvas from '../../../common/OffCanvas';
import { useTranslation } from "react-i18next";
import Select, { StylesConfig } from 'react-select';
import { useLocation } from 'react-router-dom';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import CustomPagination from "../../../common/Pagination";
import { getPageSizeArray, getFilteredList, paginationStyles, getValueFromResource } from "../../../common/timeLiveFunction";
import { ShowSwalWithConfirmationMessage } from "../../../common/SweetAlert";
import moment from "moment";
import { ShowToast } from "../../../common/Toastr";
import ExpenseApprovalFilter from "./ExpenseApprovalFilter";
import ExpenseApprovalItem from "./ExpenseApprovalItem";
import Loader from "../../../common/Loader";
import PageSizeSelect from "../../../common/PageSizeSelect";
const ExpenseApproval = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const generalObject = {
        "name": getValueFromResource("Filters", dispatch, t),
        "width": "500px",
        "componentName": <ExpenseApprovalFilter t={t} />
    }

    const { expenseApprovalList, isLoading, isReload, startExpenseApprovalDate, endExpenseApprovalDate
        , currentPage, pageSize, totalItems, start, recordsFiltered, direction, columnIndex, search, Employeesdata, Projectdata, includeDateRange
    } = useAppSelector((state) => state.expenseApproval);
    const { pageId, menuList, accountPreferenceList, IsEdit, sessionAccountEmployeeId, maxMenuHeight } = useAppSelector((state) => state.globalState);
    const modalAttachmentRef = useRef<any>(null);
    const location = useLocation();
    const navigate = useNavigate();
    const options: any = getPageSizeArray();
    const currentDate = new Date();
    const [SelectedStartDate, setSelectedStartDate] = useState(() => {
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() - 3);
        return newDate;
    });
    const [SelectedEndDate, setSelectedEndDate] = useState(currentDate);
    // const { fromDashboard, widgetFilters } = location.state || {};
        const params = new URLSearchParams(location.search);
    const encoded = params.get("data");
    const parsedState = encoded ? JSON.parse(decodeURIComponent(encoded)) : {};
    const { widgetFilters = null,fromDashboard = false,status = null} = parsedState;

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };
        if (accountPreferenceList.length > 0) {

        }
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    useEffect(() => {
        if (isReload) {
            let approverEmployeeId: Number = 0;
            if (sessionAccountEmployeeId) {
                approverEmployeeId = sessionAccountEmployeeId;
            }

            // const commaSeparatedEmployeeValues = Employeesdata.some((item: any) => item.isSelected === 1) ? Employeesdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
            // const commaSeparatedProjectValues = Projectdata.some((item: any) => item.isSelected === 1) ? Projectdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
            const commaSeparatedEmployeeValues = Employeesdata.some((item: any) => item.isSelected === 1) ? Employeesdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
            const commaSeparatedProjectValues = Projectdata.some((item: any) => item.isSelected === 1) ? Projectdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";

            let startDate = moment(startExpenseApprovalDate).format('MM-DD-YYYY');
            let endDate = moment(endExpenseApprovalDate).format('MM-DD-YYYY');
            let employeeValues = commaSeparatedEmployeeValues;
            let projectValues = commaSeparatedProjectValues;
            let includeDateRangeValue = includeDateRange;

            if (fromDashboard) {
                if (widgetFilters?.DateRange) {
                    startDate = moment(widgetFilters.DateRange.startDate).format('MM-DD-YYYY');
                    endDate = moment(widgetFilters.DateRange.endDate).format('MM-DD-YYYY');
                }

                if (widgetFilters?.AccountEmployeeId?.length > 0) {
                    employeeValues = widgetFilters.AccountEmployeeId.join(', ');
                }

                if (widgetFilters?.AccountProjectId?.length > 0) {
                    projectValues = widgetFilters.AccountProjectId.join(', ');
                }

               // projectValues = "0";

                if (widgetFilters?.IncludeDateRange !== undefined) {
                    includeDateRangeValue = widgetFilters.IncludeDateRange;
                }
            }
            // let SearchParamsValues = { page: currentPage, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: `${moment(startExpenseApprovalDate).format('MM-DD-YYYY')}`, EndDate: `${moment(endExpenseApprovalDate).format('MM-DD-YYYY')}`, EmployeeValues: `${commaSeparatedEmployeeValues}`, ProjectValues: `${commaSeparatedProjectValues}`, includeDateRange: `${includeDateRange}`, ApproverEmployeeId: `${approverEmployeeId}` };
            let SearchParamsValues = {
                page: currentPage,
                pageSize: pageSize,
                start: start,
                Order: columnIndex,
                OrderDir: direction,
                search: " ",
                StartDate: startDate,
                EndDate: endDate,
                EmployeeValues: employeeValues,
                ProjectValues: projectValues,
                includeDateRange: `${includeDateRangeValue}`,
                ApproverEmployeeId: `${approverEmployeeId}`
            };


            dispatch(getAllExpenseEntryApprovalsAsync(SearchParamsValues));

        }
    }, [isReload]);

    useEffect(() => {

        let approverEmployeeId: Number = 0;
        if (sessionAccountEmployeeId) {
            approverEmployeeId = sessionAccountEmployeeId;
        }

        // dispatch(setDateRangeValue({ startDate: moment(SelectedStartDate).format('MM-DD-YYYY'), endDate: moment(SelectedEndDate).format('MM-DD-YYYY') }));
        // const commaSeparatedEmployeeValues = Employeesdata.some((item: any) => item.isSelected === 1) ? Employeesdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
        // const commaSeparatedProjectValues = Projectdata.some((item: any) => item.isSelected === 1) ? Projectdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
        // const commaSeparatedEmployeeValues = "0";
        // const commaSeparatedProjectValues = "0";
        // let SearchParamsValues = { page: currentPage, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: `${moment(SelectedStartDate).format('MM-DD-YYYY')}`, EndDate: `${moment(SelectedEndDate).format('MM-DD-YYYY')}`, EmployeeValues: `${commaSeparatedEmployeeValues}`, ProjectValues: `${commaSeparatedProjectValues}`, includeDateRange: `${includeDateRange}`, ApproverEmployeeId: `${approverEmployeeId}` };
        let startDate = moment(SelectedStartDate).format('MM-DD-YYYY');
        let endDate = moment(SelectedEndDate).format('MM-DD-YYYY');
        let employeeValues = "0";
        let projectValues = "0";
        let includeDateRangeValue = includeDateRange;

        if (fromDashboard) {
            if (widgetFilters?.DateRange) {
                startDate = moment(widgetFilters.DateRange.startDate).format('MM-DD-YYYY');
                endDate = moment(widgetFilters.DateRange.endDate).format('MM-DD-YYYY');
            }

            if (widgetFilters?.AccountEmployeeId?.length > 0) {
                employeeValues = widgetFilters.AccountEmployeeId.join(', ');
            }
            if (widgetFilters?.AccountProjectId?.length > 0) {
                    projectValues = widgetFilters.AccountProjectId.join(', ');
            }
            // projectValues = "0";

            if (widgetFilters?.IncludeDateRange !== undefined) {
                includeDateRangeValue = widgetFilters.IncludeDateRange;
            }
        }

        dispatch(setDateRangeValue({
            startDate,
            endDate
        }));

        let SearchParamsValues = {
            page: currentPage,
            pageSize: pageSize,
            start: start,
            Order: columnIndex,
            OrderDir: direction,
            search: " ",
            StartDate: startDate,
            EndDate: endDate,
            EmployeeValues: employeeValues,
            ProjectValues: projectValues,
            includeDateRange: `${includeDateRangeValue}`,
            ApproverEmployeeId: `${approverEmployeeId}`
        };
        dispatch(getAllExpenseEntryApprovalsAsync(SearchParamsValues))
            .unwrap()
            .then((originalPromiseResult) => {
                dispatch(setIsRemoveFilterSetting(false));

            })
            .catch((rejectedValueOrSerializedError) => {
            })

    }, [dispatch]);

    const handlePageSizeChange = (event: any) => {
        const { value } = event;
        dispatch(setPageSize(Number(value)));
        let approverEmployeeId: Number = 0;
        if (sessionAccountEmployeeId) {
            approverEmployeeId = sessionAccountEmployeeId;
        }
        const commaSeparatedEmployeeValues = Employeesdata.some((item: any) => item.isSelected === 1) ? Employeesdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
        const commaSeparatedProjectValues = Projectdata.some((item: any) => item.isSelected === 1) ? Projectdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
        let SearchParamsValues = { page: 1, pageSize: value, start: 0, Order: columnIndex, OrderDir: direction, search: " ", StartDate: `${moment(startExpenseApprovalDate).format('MM-DD-YYYY')}`, EndDate: `${moment(endExpenseApprovalDate).format('MM-DD-YYYY')}`, EmployeeValues: `${commaSeparatedEmployeeValues}`, ProjectValues: `${commaSeparatedProjectValues}`, includeDateRange: `${includeDateRange}`, ApproverEmployeeId: `${approverEmployeeId}` };
        dispatch(getAllExpenseEntryApprovalsAsync(SearchParamsValues));
    };

    const handlePageChange = (pageNumber: any) => {
        const start = (pageNumber - 1) * pageSize;
        let approverEmployeeId: Number = 0;
        if (sessionAccountEmployeeId) {
            approverEmployeeId = sessionAccountEmployeeId;
        }
        const commaSeparatedEmployeeValues = Employeesdata.some((item: any) => item.isSelected === 1) ? Employeesdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
        const commaSeparatedProjectValues = Projectdata.some((item: any) => item.isSelected === 1) ? Projectdata.filter((item: any) => item.isSelected == 1).map((item: any) => item.value).join(', ') : "0";
        let SearchParamsValues = { page: pageNumber, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: `${moment(startExpenseApprovalDate).format('MM-DD-YYYY')}`, EndDate: `${moment(endExpenseApprovalDate).format('MM-DD-YYYY')}`, EmployeeValues: `${commaSeparatedEmployeeValues}`, ProjectValues: `${commaSeparatedProjectValues}`, includeDateRange: `${includeDateRange}`, ApproverEmployeeId: `${approverEmployeeId}` };
        dispatch(getAllExpenseEntryApprovalsAsync(SearchParamsValues));
    };

    const handleApprovedOrRejectedClick = (e: any) => {
        e.preventDefault();
        const id = e.target.id;
        ShowSwalWithConfirmationMessage(`Are you sure you want to ${id} this record?`, "", `Yes, Proceed`)
            .then((result) => {
                if (result) {
                    dispatch(ApproveOrRejectSelectedAsync({ List: expenseApprovalList, id: id, IncludeDateRange: includeDateRange, ExpenseEntryStartDate: startExpenseApprovalDate, ExpenseEntryEndDate: endExpenseApprovalDate }))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Approved Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top fixed-top bg-white">
                    <h3 className="card-title fw-bold mainHeading"  >
                        {/* {t('My Approvals')} */}
                        {getValueFromResource('Expense Approval', dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={paginationStyles}
                                maxMenuHeight={maxMenuHeight}
                                options={options}
                                value={options.find((option: any) => parseInt(option.value) == pageSize)}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            /> */}
                            <PageSizeSelect onChange={handlePageSizeChange} />


                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(expenseApprovalList.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(currentPage - 1) * pageSize}
                                    t={t}
                                    recordsFiltered={recordsFiltered}
                                >
                                </CustomPagination>
                            ) : null}
                        </div> */}

                        {(expenseApprovalList.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(currentPage - 1) * pageSize}
                                        t={t}
                                        recordsFiltered={recordsFiltered}
                                    />
                                </div>
                            </>
                        )}

                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <a id="kt_OffCanvas"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("Filters")}
                            {getValueFromResource('Filters', dispatch, t)}
                            data-tooltip-place="bottom">
                            <i className="bi bi-filter fs-3 iconColor"></i>
                        </a>
                        {IsEdit ? (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <button
                                    type="button"
                                    id="Approve"
                                    style={{ marginRight: '2px', display: expenseApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                    className={`btn btn-sm btn-outline me-2 mb-0 btn-active-light-success text-success fs-7`}
                                    onClick={(e: any) => handleApprovedOrRejectedClick(e)}
                                >
                                    {/* {t('Approve Selected')} */}
                                    {getValueFromResource('Approve Selected', dispatch, t)}
                                </button>
                                <button
                                    type="button"
                                    id="Reject"
                                    className={`btn btn-sm btn-outline me-0 mb-0 btn-active-light-danger text-danger fs-7`}
                                    onClick={(e: any) => handleApprovedOrRejectedClick(e)}
                                    style={{ marginRight: '2px', display: expenseApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    {/* {t('Reject Selected')} */}
                                    {getValueFromResource('Reject Selected', dispatch, t)}
                                </button>
                            </>
                        ) : null}
                    </div>
                </div>
                {/* <div className="card-body" > */}
                <div className="card-Report-body">
                    <div className="table-responsive">
                        <ExpenseApprovalItem expenseApprovalList={expenseApprovalList} t={t} IsEdit={IsEdit} />
                    </div>
                </div>
            </div>
            <OffCanvas obj={generalObject} />
        </>
    )
}

export default ExpenseApproval;